import { Injectable } from "@angular/core";
import { Template } from "../models/template.model";
import { HttpService } from "../../../../app/shared/http.service";
import { APIEndpoints } from "../../../../config/apiEndpoint.config";
import { Observable } from "rxjs";
import { first } from "rxjs/operators";
import { saveAs } from "file-saver";
import { TemplateLanguage } from "../../../shared/Models/enums/TemplateLanguage.enum";
import { TemplateType } from "../../../shared/Models/enums/TemplateType.enum";
import * as mime from "mime-db";

@Injectable()
export class TemplateService {
  constructor(private readonly httpService: HttpService) {}

  getAllTemplates(): Observable<Template[]> {
    return this.httpService.get<Template[]>(APIEndpoints.templateList, true);
  }

  getLatestTemplates(): Observable<Template[]> {
    return this.httpService.get<Template[]>(APIEndpoints.latestTemplates, true);
  }

  async createTemplate(
    type: TemplateType,
    language: TemplateLanguage,
    networkOwnerId: string,
    file: any
  ) {
    const data = await this.getTemplateData(file);
    const dto = {
      type: type,
      language: language,
      networkOwnerId: networkOwnerId,
      data: data,
      mimetype: file.type,
    };

    await this.httpService
      .post(APIEndpoints.createTemplate, dto, true)
      .toPromise();
  }

  async uploadTemplate(templateId: string, file: any) {
    const data = await this.getTemplateData(file);
    const dto = {
      templateId: templateId,
      data: data,
      mimetype: file.type,
    };

    await this.httpService
      .post(APIEndpoints.uploadTemplate, dto, true)
      .toPromise();
  }

  async delete(templateId: string) {
    var dto = {
      id: templateId,
    };

    await this.httpService
      .post(APIEndpoints.deleteTemplate, dto, true)
      .toPromise();
  }

  async download(template: Template) {
    const request = this.httpService.getBlob(template.templateUrl);
    request.pipe(first()).subscribe((data) => {
      const extension = mime[data.fileType].extensions[0];
      saveAs(data.data, `version${template.version}.${extension}`);
    });
    await request.toPromise();
  }

  private async getTemplateData(file: any) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    return await new Promise<string>((res) => {
      reader.onload = () => {
        res((reader.result as string).split(",")[1]);
      };
    });
  }
}
